import { User } from '../models/User';
import { Group } from '../models/Group';

export function isUser(item: User | Group): item is User {
  return (item as User).firstName !== undefined;
}
